export const BRANDS = ["Linde","Toyota","Crown","Hyster","Mitsubishi","Komatsu","Caterpillar","Nissan","Yale","BT","Nichiyu","Heli","Enforcer","Baoli"];
export const FUELS = ["LPG","Diesel","Petrol","Electric","Lithium"];
export const MACHINE_TYPES = ["Counterbalance","Reach Truck","Pallet Jack","Walkie Stacker","Order Picker","Other"];
export const CAPACITIES = ["Under 1.5T","1.5–2T","2–2.5T","2.5–3.5T","3.5–5T","5T+","Unknown"];
export const SERVICE_TYPES = [
  "Scheduled Service","Breakdown / Repair","Engine Problem","LPG / Fuel Problem",
  "Hydraulic Problem","Electrical Problem","Brake Problem","Steering Problem",
  "Mast / Carriage Problem","Forklift Not Starting","Forklift Not Driving",
  "Forklift Not Lifting","Battery / Charger Problem","Safety Inspection","Other"
];
export const SUBURBS = ["Brisbane","Brisbane Port","Bulimba","Morningside","Cannon Hill","Murarrie","Hemmant","Eagle Farm","Rocklea","Acacia Ridge","Coopers Plains","Archerfield","Logan","Beenleigh","Ipswich"];
export const PHONE = "0482 712 785";
export const PHONE_HREF = "tel:+61482712785";
export const EMAIL = "forkfixqld@gmail.com";
export const HOURS = "Mon–Fri 7:00am – 5:00pm";
export const ABN = "61 624 878 276";
export const BUSINESS_NAME = "Forkfix";

export function priceLabel(f, mode) {
  // mode: "hire" → always show daily rate (or weekly if daily is 0); "sale" → always show sale price
  if (mode === "hire") {
    if (f.daily_hire_price) return `From $${f.daily_hire_price}/day`;
    if (f.weekly_hire_price) return `From $${f.weekly_hire_price}/week`;
    return "Rate on request";
  }
  if (mode === "sale") return f.sale_price ? `$${f.sale_price.toLocaleString()} + GST` : "POA";
  if (f.listing_type === "hire") {
    if (f.daily_hire_price) return `From $${f.daily_hire_price}/day`;
    if (f.weekly_hire_price) return `From $${f.weekly_hire_price}/week`;
    return "Rate on request";
  }
  if (f.sale_price) return `$${f.sale_price.toLocaleString()} + GST`;
  return "POA";
}

export function statusBadgeClass(status) {
  if (status === "sold") return "ff-badge-sold";
  if (status === "on_hire") return "ff-badge-onhire";
  return "ff-badge-avail";
}

export function statusBadgeLabel(status) {
  if (status === "sold") return "SOLD";
  if (status === "on_hire") return "ON HIRE";
  return "AVAILABLE";
}
